/* EZ Rides: guide pages (sections/ez-guide.liquid).
   1. "Print this list" prints only that checklist.
   2. Trunk fit checker: compares the reader's trunk with each model's folded size. */
(function () {
  if (window.__ezGuide) return;
  window.__ezGuide = true;

  // 1. Print one checklist
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ez-print]');
    if (!btn) return;
    var area = btn.closest('[data-ez-print-area]');
    if (!area) { window.print(); return; }
    area.classList.add('is-printing');
    document.body.classList.add('ez-printing');
    var done = function () {
      area.classList.remove('is-printing');
      document.body.classList.remove('ez-printing');
      window.removeEventListener('afterprint', done);
    };
    window.addEventListener('afterprint', done);
    window.print();
    setTimeout(done, 1500);
  });

  // 2. Trunk fit checker
  var TIGHT_CM = 5; // less room than this on any side reads as "tight"

  function permutations(d) {
    var a = d[0], b = d[1], c = d[2];
    return [[a, b, c], [a, c, b], [b, a, c], [b, c, a], [c, a, b], [c, b, a]];
  }

  // Best orientation: x along the floor depth, y across the opening, z up.
  function check(dims, trunk) {
    var best = null;
    permutations(dims).forEach(function (p) {
      var widthLimit = trunk.e > 0 ? Math.min(trunk.w, trunk.e) : trunk.w;
      var room = Math.min(trunk.d - p[0], widthLimit - p[1], trunk.h - p[2]);
      if (best === null || room > best) best = room;
    });
    return best;
  }

  function setup(root) {
    var form = root.querySelector('[data-ez-fit-form]');
    var items = root.querySelectorAll('.ez-g-fit__item');
    if (!form || !items.length) return;

    function unit() {
      var r = form.querySelector('input[type="radio"]:checked');
      return r ? r.value : 'cm';
    }
    function read(name) {
      var v = parseFloat(form.elements[name].value);
      if (isNaN(v) || v <= 0) return 0;
      return unit() === 'in' ? v * 2.54 : v;
    }
    function fmt(cm) {
      return unit() === 'in' ? (Math.abs(cm) / 2.54).toFixed(1) + ' in' : Math.round(Math.abs(cm)) + ' cm';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var trunk = { w: read('w'), h: read('h'), d: read('d'), e: read('e') };
      if (!trunk.w || !trunk.h || !trunk.d) {
        var first = ['w', 'h', 'd'].filter(function (n) { return !read(n); })[0];
        if (first) form.elements[first].focus();
        return;
      }
      items.forEach(function (item) {
        var dims = (item.getAttribute('data-dims') || '').split(/[x×*]/i).map(function (n) { return parseFloat(n); });
        var out = item.querySelector('[data-verdict]');
        if (dims.length !== 3 || dims.some(isNaN)) { out.textContent = 'Ask us'; return; }
        var room = check(dims, trunk);
        out.classList.remove('is-ok', 'is-tight', 'is-no');
        if (room >= TIGHT_CM) {
          out.textContent = 'Should fit · ' + fmt(room) + ' to spare';
          out.classList.add('is-ok');
        } else if (room >= 0) {
          out.textContent = 'Tight · measure again';
          out.classList.add('is-tight');
        } else {
          out.textContent = 'Too big by ' + fmt(room);
          out.classList.add('is-no');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ez-fit]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
